import { render, staticRenderFns } from "./Balancecredits.vue?vue&type=template&id=d1f81e2e&scoped=true&"
import script from "./Balancecredits.vue?vue&type=script&lang=js&"
export * from "./Balancecredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f81e2e",
  null
  
)

export default component.exports